// TODO set transform origin prop of all elements on index change

import WidgetBase from '../widget.base';
import { each } from 'App/lib/util';
import featSniffer from 'App/lib/featureDetection';

export default class GraphicalCalloutCarouselWidget extends WidgetBase {
    static selector = '[data-ww-graphical-callout-carousel]';
    imgSelector = '[data-slide-image]';
    inactiveSlideScale = 0.8;
    inactiveSlideOpacity = 0.7;
    activeImageScale = 1.3;
    threshold = 100;
    innerContainer;
    slides;
    pagerTriggers;
    pagerWidth;
    prevIndex;
    _index;
    activatingIndex;

    constructor(el) {
        super(el);

        if(!this.el) {
            return;
        }

        // set intial state for dom/internal 
        this.innerContainer = this.el.querySelector('[data-carousel-inner]');
        this.slides = this.el.querySelectorAll('[data-carousel-slide]');
        this.pager = this.el.querySelector('[data-pager]');
        this.pagerTriggers = this.el.querySelectorAll('[data-pager-trigger]');
        this.pagerIndicator = this.el.querySelector('[data-pager-indicator]');

        this.index = this.el.dataset.index ? parseInt(this.el.dataset.index) : 0;

        // // Set initial transform on slides
        // each(this.slides, (slide, i) => {
        //     if (i !== this.index) {
        //         // active slide
        //         this.setInactiveStyles(slide);
        //     }else{
        //         // active slide
        //         this.setActiveStyles(slide);
        //     }
        // });

        // add pager event listeners
        each(this.pagerTriggers, (trigger, i) => {
            trigger.addEventListener('click', () => {
                if (!trigger.classList.contains('active')) {
                    this.index = i;
                }
            })
        });

        var imageClickFunction = (event) => {
            this.index = parseInt(event.currentTarget.parentElement.parentElement.attributes["data-carousel-index"].value);
        };

        each(this.slides, (slide, i) => {
            var index = i;
            slide.querySelector(".ww-graphical-callout-carousel__slide__image").addEventListener('click', imageClickFunction);
        });

        // add touch events if supported
        if (featSniffer.touch()) {
            this.addTouchEvents(this.innerContainer);
        }

        // update on resize
        window.addEventListener('resize', () => {
            this.update(this.index);
        });

        // tell dom we're ready
        setTimeout(() => this.loaded());
    }

    get index() {
        return this._index;
    }

    set index(i) {
        if (i === this._index) {
            return;
        }
        
        const oldIndex = this.index;
        this._index = i;

        // remove active state from previous slide
        if(typeof oldIndex !== 'undefined') {
            this.slides[oldIndex].classList.remove('active');
            this.pagerTriggers[oldIndex].classList.remove('active');

            if(oldIndex - 1 >= 0) {
                this.pagerTriggers[oldIndex - 1].classList.remove('active--prev');
            }
            if(oldIndex + 1 <= this.slides.length - 1) {
                this.pagerTriggers[oldIndex + 1].classList.remove('active--next');
            }
            
        }

        // add active state to new slide
        this.slides[i].classList.add('active');
        
        // update pager state
        this.pagerTriggers[i].classList.add('active');

        if (i - 1 >= 0) {
            this.pagerTriggers[i - 1].classList.add('active--prev');
        }
        if (i + 1 <= this.slides.length - 1) {
            this.pagerTriggers[i + 1].classList.add('active--next');
        }

        this.update(i, true);
    }

    update(index, shouldUpdateStyle = false) {
        this.slideWidth = this.slides[index].offsetWidth;
        this.pagerWidth = this.pager.offsetWidth;
        const newOpacity = (this.slideWidth * 3) > window.innerWidth ? 0.7 : 1;        

        if (this.inactiveSlideOpacity !== newOpacity || shouldUpdateStyle) {
            this.inactiveSlideOpacity = newOpacity;

            // update slide styles
            this.setActiveStyles(index);
            each(this.slides, (slide, i) => {
                if (i !== index) {
                    this.setInactiveStyles(i);
                }
            })
        }

        // update pager styles (the last index * 1 is added to pixel push, required because my math sucks)
        this.setTransformX(this.pagerIndicator, this.pagerWidth/(this.slides.length - 1) * (index - 1));
        
        this.gutter = (window.innerWidth - this.slideWidth) / 2;    

        if(index === 0) {
            this.setTransformX(this.innerContainer, this.gutter)
        }else if(index === 1){
            this.setTransformX(this.innerContainer, (this.gutter - this.slideWidth))
        }else{
            this.setTransformX(this.innerContainer, (this.slideWidth) * -index + (this.gutter) )
        }

    }

    setTransformX(el, value) {
        el.style.transform = 'translate3d(' + value + 'px, 0, 0)';
    }
    
    addTouchEvents(element) {
        let isTouchStart = false;

        // initial mouse X for `mousedown`
        let touchX;
        let touchY;

        // element transform style before/after
        let transformX;

        // element X before and after move
        let elementX = 0;

        element.addEventListener('touchstart', onTouchStart.bind(this));
    
        /**
         * Listens to `mousedown` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchStart(event) {
            element.classList.add('dragging');
            touchX = event.touches[0].clientX;
            touchY = event.touches[0].clientY;
            isTouchStart = true;

            transformX = parseTransformX(element.style.transform);
        }
    
        // mouse button released
        element.addEventListener('touchend', onTouchEnd.bind(this));
    
        /**
         * Listens to `mouseup` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchEnd(event) {
            isTouchStart = false;
            element.classList.remove('dragging');
            
            elementX = element.style.transform ? parseTransformX(element.style.transform) : transformX;
            
            const transformDelta = elementX - transformX;
            
            if (Math.abs(transformDelta) > this.threshold) {
                if(transformDelta < 0) {
                    if(this.index !== this.slides.length - 1) {
                        this.index++;
                    }else{
                        // sets slide back to start position
                        element.style.transform = 'translate3d(' + transformX + 'px, 0, 0)';        
                        this.setActiveStyles(this.index);
                    }
                }else{
                    if(this.index !== 0) {
                        this.index--;
                    }else{
                        // sets slide back to start position
                        element.style.transform = 'translate3d(' + transformX + 'px, 0, 0)';        
                        this.setActiveStyles(this.index);
                    }
                }
            }else{
                element.style.transform = 'translate3d(' + transformX + 'px, 0, 0)';

                if (this.activatingIndex) {
                    this.setInactiveStyles(this.activatingIndex);
                }
                //sets inactive slide back to defaut
                
                // sets slide back to start position
                this.setActiveStyles(this.index);
            }
        }

        // gets the x transform value from an element with a transform3d style applied
        function parseTransformX(transform) {
            return parseInt(transform.split('(')[1].split(',')[0])
        }
    
        // need to attach to the entire document
        // in order to take full width and height
        // this ensures the element keeps up with the mouse
        document.addEventListener('touchmove', onTouchMove.bind(this));

        /**
         * Listens to `mousemove` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchMove(event) {
            if (!isTouchStart) return;
            var deltaX = event.touches[0].clientX - touchX;
            var deltaY = event.touches[0].clientY - touchY;
            
            const absDeltaX = Math.abs(deltaX);
            const absDeltaY = Math.abs(deltaY);

            if(absDeltaY > absDeltaX) {
                return false;
            }

            element.style.transform = 'translate3d(' + (transformX + deltaX) + 'px, 0, 0)';
            const deltaRatio = (absDeltaX/this.slideWidth); //ratio of mousemove delta to slide width
            
            // change transform origin
            let originRatio = this.ratioUtility(deltaRatio, 50);
            let originRight = deltaX < 0 ? 50 + originRatio : 50 - originRatio;
            this.slides[this.index].style.transformOrigin = `${originRight}% 50%`;
            
            let scaleRatio = this.ratioUtility(deltaRatio, 1 - this.inactiveSlideScale);
            this.slides[this.index].style.transform = `scale(${1 - scaleRatio })`;

            let opacityRatio = this.ratioUtility(deltaRatio, 1 - this.inactiveSlideOpacity);
            this.slides[this.index].style.opacity = 1 - opacityRatio;
            
            let imageScaleRatio = this.ratioUtility(deltaRatio, this.activeImageScale - 1);
            this.slides[this.index].querySelector(this.imgSelector).style.transform = `scale(${this.activeImageScale - imageScaleRatio})`;

            this.activatingIndex = null;

            if (deltaX < 0 && this.index < this.slides.length - 1) {
                this.activatingIndex = this.index + 1;
            }
            
            if(deltaX > 0 && this.index > 0) {
                // prev
                this.activatingIndex = this.index - 1;
                // activatingSlide = this.slides[this.index - 1];
            }
            
            if(this.activatingIndex !== null) {
                const activatingSlide = this.slides[this.activatingIndex];
                
                // change transform origin
                originRight = deltaX < 0 ? originRatio : 100 - originRatio;
                activatingSlide.style.transformOrigin = `${originRight}% 50%`;

                // scale slide bigger
                activatingSlide.style.transform = `scale(${this.inactiveSlideScale + scaleRatio})`;
                
                // scale opacity
                activatingSlide.style.opacity = this.inactiveSlideOpacity + opacityRatio;

                // scale image seperately
                activatingSlide.querySelector(this.imgSelector).style.transform = `scale(${1 + imageScaleRatio})`;
                

            }
        }
    }

    ratioUtility(delta, max) {
        const ratio = delta * max;
        return ratio < max ? ratio : max;
    }

    setActiveStyles(i) {
        this.slides[i].style.transform = 'scale(1)';
        this.slides[i].style.transformOrigin = '50% 50%';
        this.slides[i].style.opacity = 1;
        this.slides[i].querySelector(this.imgSelector).style.transform = `scale(${this.activeImageScale})`;
    }
    
    setInactiveStyles(i) {
        const originRight = i < this.index ? '100%' : '0%';
        const opacity = (i === this.index - 1 || i === this.index + 1) ? this.inactiveSlideOpacity : 0;
        this.slides[i].style.transformOrigin = null;
        this.slides[i].style.transform = `scale(${this.inactiveSlideScale})`;
        this.slides[i].style.opacity = opacity;
        this.slides[i].querySelector(this.imgSelector).style.transform = 'scale(1)';
    }
}